module.exports = __webpack_public_path__ + "img/BrandMe_IA_RenderCafeteria_2.9743e921.png";